import { jsx as _jsx } from "react/jsx-runtime";
var DetailPersonalInfo = function () {
    return (_jsx("div", { className: "flex h-full" }));
};
export default DetailPersonalInfo;
